import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const WithdrawalService = {
  getListWithdrawal(page, perPage, name, period) {
    return axios.get(
      `${cleanedBackendUrl}/withdrawal`,
      {
        params: {
          page: page,
          perPage: perPage,
          name: name,
          period: period
        }
      }
    );
  },
  addWithdrawal(partnerId, period) {
    return axios.post(
      `${cleanedBackendUrl}/withdrawal/${partnerId}`,
      {
        period: period
      }
    )
  }
}

export default WithdrawalService;